export default __webpack_public_path__ + "static/media/district-min.9362e11e.png";